import PrimaryButton from "components/primaryButton/PrimaryButton";
import TextInput from "components/textInput/TextInput";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { styled } from "styled-components";

const InputTextArea = styled(TextInput)`
  height: 200px;
`;

const OutputControls = styled.div`
  display: flex;
  gap: 10px;

  .left {
    margin-right: auto;
  }
  .right {
    margin-left: auto;
  }

  @media (max-width: 390px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

interface EncodeOutputProps {
  output: string;
  header: string;
}

const EncodeOutput = (props: EncodeOutputProps) => {
  const { output, header } = props;

  const [copied, setCopied] = useState(false);

  const handleStartOver = () => {
    window.location.reload();
  };

  const handleCopy = () => {
    setCopied(true);
  };

  return (
    <>
      <span className="mb-4 d-block">{header}</span>
      <InputTextArea
        disabled={true}
        readOnly={true}
        spellCheck={false}
        className="form-control mb-4"
        textarea={true}
        value={output}
      />
      <OutputControls>
        <CopyToClipboard text={output}>
          <PrimaryButton className="left" type="button" onClick={handleCopy}>
            {!copied && <span>Copy to clipboard</span>}
            {copied && <span>Copied to clipboard</span>}
          </PrimaryButton>
        </CopyToClipboard>
        <PrimaryButton
          className="right"
          type="button"
          onClick={handleStartOver}
        >
          Start Over
        </PrimaryButton>
      </OutputControls>
    </>
  );
};

export default EncodeOutput;
